module.exports = __webpack_public_path__ + "static/SNY04353-6777cd5d82de4d697623529410b91bfd.jpg";